<template>
  <div class="question-content">
    <v-container fluid grid-list-md>
      <!-- <wes-q-text v-bind:metadata="question"></wes-q-text> -->
      <wes-q-text v-bind:metadata="question"></wes-q-text>

      <v-layout row wrap>

        <v-flex xs12>
          <div class="clearfix buttons-container">
            <v-btn
              class="button"
              rounded
              color="primary"
              dark
              :curentAnswer="currentAnswer"
              @click="onFillZerosClicked(currentAnswer)"
            >Fill With Zeros</v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <hr />
          <br />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs4>
          <p class="column-header">{{ colHeaders[0].colLabel }}</p>
        </v-flex>
        <v-flex v-for="colHeaders in filteredColHeaders" :key="colHeaders.colHeader" xs2>
          <p class="column-header">
            {{ colHeaders.colHeader }}
            <br />
            {{ colHeaders.colLabel }}
          </p>
        </v-flex>
      </v-layout>

      <br />

      <v-layout
        v-for="(category, categoryIndex) in this.labels"
        :key="category.categoryHeading"
        row
        wrap
      >
        <v-flex xs4>
          <p class="row-label">{{ category.categoryHeading }}. {{ category.categoryLabel }}</p>
        </v-flex>

        <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs2>
          <v-text-field
            v-model="currentAnswer[categoryIndex].answerFields[0][0]"
            prefix="$"
            suffix=""
            height="32"
            @change="updateAnswerValue(categoryIndex, 0, 0, $event), addCommas(currentAnswer[categoryIndex].answerFields[0][0])"
          ></v-text-field>
        </v-flex>
        <v-flex v-else :currentAnswer="currentAnswer" xs2>
          <v-text-field :value="grandColTotals(0)" prefix="$" suffix="" readonly></v-text-field>
        </v-flex>

        <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs2>
          <v-text-field
            v-model="currentAnswer[categoryIndex].answerFields[0][1]"
            prefix="$"
            suffix=""
            height="32"
            @change="updateAnswerValue(categoryIndex, 0, 1, $event), addCommas(currentAnswer[categoryIndex].answerFields[0][1])"
          ></v-text-field>
        </v-flex>
        <v-flex v-else :currentAnswer="currentAnswer" xs2>
          <v-text-field :value="grandColTotals(1)" prefix="$" suffix="" readonly></v-text-field>
        </v-flex>

        <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs2>
          <v-text-field
            v-model="currentAnswer[categoryIndex].answerFields[0][2]"
            prefix="$"
            suffix=""
            height="32"
            @change="updateAnswerValue(categoryIndex, 0, 2, $event), addCommas(currentAnswer[categoryIndex].answerFields[0][2])"
          ></v-text-field>
        </v-flex>
        <v-flex v-else :currentAnswer="currentAnswer" xs2>
          <v-text-field :value="grandColTotals(2)" prefix="$" suffix="" height="32" readonly></v-text-field>
        </v-flex>

        <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs2>
          <v-text-field :value="totalRows(categoryIndex, 0, 3)" prefix="$" suffix="" height="32" readonly></v-text-field>
        </v-flex>
        <v-flex v-else :currentAnswer="currentAnswer" xs2>
          <v-text-field
            :value="total3(grandColTotals(0), grandColTotals(1), grandColTotals(2))"
            prefix="$"
            suffix=""
            height="32"
            readonly
          ></v-text-field>
        </v-flex>
      </v-layout>

      <br/>

      <v-layout row wrap>
        <v-flex xs4>
          <p class="row-label">Cross check: totals in row j above should match the FY 2021 amounts from question 5, rows a–d displayed here.</p>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs2>
          <v-text-field :value="grandColTotalsCrossCheck(0)" prefix="$" suffix="" height="32" readonly></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs2>
          <v-text-field :value="grandColTotalsCrossCheck(1)" prefix="$" suffix="" height="32" readonly></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs2>
          <v-text-field :value="grandColTotalsCrossCheck(2)" prefix="$" suffix="" height="32" readonly></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs2>
          <v-text-field
            :value="total3(grandColTotalsCrossCheck(0), grandColTotalsCrossCheck(1), grandColTotalsCrossCheck(2))"
            prefix="$"
            suffix=""
            height="32"
            readonly
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs10>
          <answer-explain
            :label="question.explanation.label"
            v-bind:explaination="x"
          ></answer-explain>
        </v-flex>
        <v-flex xs1></v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1>
          <v-icon class="help-ico" v-on:click="onHandleHelpClicked(true)">fa fa-question-circle</v-icon>
        </v-flex>
        <v-flex xs1></v-flex>
        <v-flex xs10>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark v-on:click="onSaveClicked">Save</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { answerService } from '../../services/answerService';
import { utilityService } from '../../services/utilityService';
import { errorService } from '../../services/errorService';
export default {
  name: 'Question7',
  props: {
    question: Object,
    qId: String
  },
  data: () => ({
    isHelpDisplayed: false,
    isErrorsOverlayDisplayed: false,
    colHeaders: [
      { colHeader: '', colLabel: 'Field of R&D' },
      { colHeader: '(a)', colLabel: 'Basic Research' },
      { colHeader: '(b)', colLabel: 'Applied Research' },
      { colHeader: '(c)', colLabel: 'Experimental Development' },
      { colHeader: '(d)', colLabel: 'Total R&D conduct' }
    ],
    labels: [
      { categoryHeading: 'a', categoryLabel: 'Computer and information sciences' },
      { categoryHeading: 'b', categoryLabel: 'Geosciences, atmospheric sciences, and ocean sciences' },
      { categoryHeading: 'c', categoryLabel: 'Life sciences' },
      { categoryHeading: 'd', categoryLabel: 'Mathematics and statistics' },
      { categoryHeading: 'e', categoryLabel: 'Physical sciences' },
      { categoryHeading: 'f', categoryLabel: 'Psychology' },
      { categoryHeading: 'g', categoryLabel: 'Social sciences' },
      { categoryHeading: 'h', categoryLabel: 'Engineering' },
      { categoryHeading: 'i', categoryLabel: 'Other fields' },
      { categoryHeading: 'j', categoryLabel: 'Total, all fields of R&D conduct' }
    ],
    currentAnswer: [
      { answerCategory: 'a', answerFields: [['1', '2', '3']] },
      { answerCategory: 'b', answerFields: [['4', '5', '6']] },
      { answerCategory: 'c', answerFields: [['7', '8', '9']] },
      { answerCategory: 'd', answerFields: [['10', '11', '12']] },
      { answerCategory: 'e', answerFields: [['13', '14', '15']] },
      { answerCategory: 'f', answerFields: [['16', '17', '18']] },
      { answerCategory: 'g', answerFields: [['19', '20', '21']] },
      { answerCategory: 'h', answerFields: [['22', '23', '24']] },
      { answerCategory: 'i', answerFields: [['25', '26', '27']] },
      { answerCategory: 'j', answerFields: [['', '', '']] }
    ],
    crossCheckAnswer: [
      { answerCategory: 'a', answerFields: [['1', '2', '3']] },
      { answerCategory: 'b', answerFields: [['4', '5', '6'], ['7', '8', '9'], ['10', '11', '12'], ['13', '14', '15'], ['', '', '']] },
      { answerCategory: 'c', answerFields: [['16', '17', '18'], ['19', '20', '21'], ['22', '23', '24'], ['25', '26', '27'], ['28', '29', '30'], ['', '', '']] },
      { answerCategory: 'd', answerFields: [['31', '32', '33'], ['', '', '']] },
      { answerCategory: 'e', answerFields: [['34', '35', '36'], ['37', '38', '39'], ['40', '41', '42'], ['43', '44', '45'], ['46', '47', '48'], ['', '', '']] },
      { answerCategory: 'f', answerFields: [['49', '50', '51'], ['52', '53', '54'], ['55', '56', '57'], ['', '', '']] },
      { answerCategory: 'g', answerFields: [['58', '59', '60'], ['61', '62', '63'], ['64', '65', '66'], ['67', '68', '69'], ['70', '71', '72'], ['', '', '']] },
      { answerCategory: 'h', answerFields: [['73', '74', '75'], ['76', '77', '78'], ['79', '80', '81'], ['82', '83', '84'], ['85', '86', '87'], ['88', '89', '90'], ['91', '92', '93'], ['94', '95', '96'], ['97', '98', '99'], ['', '', '']] },
      { answerCategory: 'i', answerFields: [['100', '101', '102'], ['103', '104', '105'], ['106', '107', '108'], ['109', '110', '111'], ['112', '113', '114'], ['115', '116', '117'], ['118', '119', '120'], ['121', '122', '123'], ['', '', '']] },
      { answerCategory: 'j', answerFields: [['', '', '']] }
    ],
    testInput1: 0,
    testInput2: 0,
    x: ''
  }),
  created () {
    console.log('Question 7 created');
  },
  methods: {
    onValueChanged: function (event) {
      console.log('On Value Changed.');
    },
    onSaveClicked: function () {
      console.log('Called save with: ' + this.currentAnswer);
      answerService.saveSurveyQuestionAnswer(0, this.$props.question.id, this.currentAnswer);
    },
    onClosePanel: function () {
    	this.isErrorsOverlayDisplayed = false;
    	this.isHelpDisplayed = false;
    },
    onErrorPanelCleared: function () {
      this.isErrorsOverlayDisplayed = false;
    },
    onHandleHelpClicked: function (bDisplay) {
      this.isHelpDisplayed = bDisplay;
    },
    onFillZerosClicked: function () {
      const categories = this.currentAnswer.length;
      for (var i = 0; i < categories; i++) {
        const rowsInCategory = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < rowsInCategory; j++) {
          const columns = this.currentAnswer[i].answerFields[j].length;
          for (var k = 0; k < columns; k++) {
            if (this.currentAnswer[i].answerFields[j][k] === '') {
              this.currentAnswer[i].answerFields[j][k] = '0';
              this.currentAnswer.push();
              // console.log('categories=' + categories + ' rowsInCategory=' + rowsInCategory + ' columns=' + columns)
            }
          }
        }
      }
    },
    updateAnswerValue: function (id, idx, item, val) {
      // const updatedVal = this.addCommasEx(val)
      // this.currentAnswer[id].answerFields[idx][item] = val;
      this.currentAnswer[id].answerFields[idx].$set(item, val);
      this.currentAnswer[id].answerFields[idx].$set(item, this.addCommasEx(val));
      Vue.nextTick(() => {
        this.currentAnswer[id].answerFields[idx].$set(item, this.addCommasEx(val));
      });
    },
    totalRows: function (category, subcategory, colTotal) {
      var total = 0;
      var totalCols = colTotal;
      for (var i = 0; i < totalCols; i++) {
        // console.log("one=" + category + ", two=" + subcategory + ", three=" + colTotal + " this.currentAnswer[category].answerFields[subcategory][i]=" + this.currentAnswer[category].answerFields[subcategory][i]);
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[subcategory][i])
      }
      return total;
    },
    totalCols: function (category, colIndex) {
      var total = 0;
      var totalRows = this.currentAnswer[category].answerFields.length;
      for (var i = 0; i < totalRows; i++) {
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][colIndex])
      }
      return total;
    },
    grandColTotals: function (col) {
      var total = 0;
      const colIndex = col;
      var totalCategories = this.currentAnswer.length;
      for (var i = 0; i < totalCategories; i++) {
        var totalSubs = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < totalSubs; j++) {
          total += utilityService.convertStringToNum(this.currentAnswer[i].answerFields[j][colIndex])
        }
      }
      return total;
    },
    grandColTotalsCrossCheck: function (col) {
      var total = 0;
      const colIndex = col;
      var totalCategories = this.crossCheckAnswer.length;
      for (var i = 0; i < totalCategories; i++) {
        var totalSubs = this.crossCheckAnswer[i].answerFields.length;
        for (var j = 0; j < totalSubs; j++) {
          total += utilityService.convertStringToNum(this.crossCheckAnswer[i].answerFields[j][colIndex])
        }
      }
      return total;
    },
    // grandColTotals: function( answerObject, col ) {
    //   var answer = answerObject;
    //   var total = 0;
    //   const colIndex = col;
    //   var totalCategories = this.answer.length;
    //   for (var i = 0; i < totalCategories; i++ ) {
    //     var totalSubs = this.answer[i].answerFields.length;
    //     for (var j = 0; j < totalSubs; j++ ) {
    //       total += utilityService.convertStringToNum(this.answer[i].answerFields[j][colIndex])
    //     }
    //   }
    //   return total;
    // },
    total3: function (num1, num2, num3) {
      return num1 + num2 + num3;
    },
    getValues: function (val1, val2) {
      console.log("Val1=" + val1 + " Val2=" + val2);
    },
    addCommas: function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => this.testInput2 = result);
      console.log(this.obj);
    },
    addCommasEx: function (value) {
      return value.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    updateInput: function (id, idx, item, val) {
      Vue.nextTick(() => {
        this.currentAnswer[id].answerFields[idx].$set(item, this.addCommasEx(val));
      });
    }
  },
  computed: {
		bDisplayHelp: function () {
			return this.isHelpDisplayed;
		},
		bDisplayErrors: function () {
			return this.isErrorsOverlayDisplayed;
    },
    filteredColHeaders () {
      return this.colHeaders.slice(1, 5);
    }
  },
  mounted () {
    // let recaptchaScript = document.createElement('script')
    // recaptchaScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.28/vue.min.js')
    // document.head.appendChild(recaptchaScript)
  },
  watch: {
    testInput1: function (newValue) {
      const result = newValue.replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => this.testInput1 = result);
    },
    question: function (newVal, oldVal) {
      const a = newVal;
    }
  }
};
</script>

<style scoped>
.v-text-field {
  margin-top: -20px;
  margin-bottom: -20px;
  margin-left: -2px;
  margin-right: -2px;
}
.column-header {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}
.row-header {
  line-height: 0px;
  margin: 0px;
  font-weight: bold;
  font-size: 14px;
}
.question-content {
  text-align: left;
  /* background-color: #598dc233; */
  /* border: 2px solid #13314f; */
  /* border-radius: 5px; */
  /* position: relative; */
  color: black;
}
.question-content > h1 {
  margin: 5px 0;
}
.question-content > p,
.question-content > ul {
  margin: 5px 10px;
}
.value-list {
  list-style: lower-latin;
}
.row-label {
  /* line-height: 25px; */
  font-weight: bold;
  font-size: 14px;

}
.buttons-container > .button {
  float: right;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: purple;
}
.v-input--is-focused > .v-input__control > .v-input__slot {
  border: 2px solid red;
}
.help-ico {
  font-size: 40px;
  line-height: 44px;
  color: #0000ffa3;
}
</style>
